import { type UseQueryResult, useQuery } from 'react-query';
import { CompantTypeService } from '../../services/wealthlane-identity-services/services/CompantTypeService';
import {
  BrokerService,
  CompanyTransferAgentService,
} from '../../services/wealthlane-customer-services';

const useGetTransferAgentCurrent = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string | null | undefined;
      value: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const transferAgentCurrent = useQuery(
    ['getTransferAgentCurrent'],
    async () => {
      return await handleRequest(
        CompanyTransferAgentService.getApiCustomerCompanyTransferAgentCurrent()
      );
    },
    {
      select(data) {
        return [
          {
            label: data.name,
            value: data.id,
          },
        ];
      },
    }
  );

  return transferAgentCurrent;
};

export default useGetTransferAgentCurrent;
